var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6242_19082",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6242_19082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1929 15.8535L7.9762 11.6368C7.88454 11.5452 7.81961 11.4459 7.78141 11.3389C7.74322 11.232 7.72412 11.1174 7.72412 10.9952C7.72412 10.873 7.74322 10.7584 7.78141 10.6514C7.81961 10.5445 7.88454 10.4452 7.9762 10.3535L12.1929 6.13685C12.3609 5.96879 12.5748 5.88477 12.8345 5.88477C13.0943 5.88477 13.3081 5.96879 13.4762 6.13685C13.6443 6.3049 13.7283 6.51879 13.7283 6.77852C13.7283 7.03824 13.6443 7.25213 13.4762 7.42018L9.9012 10.9952L13.4762 14.5702C13.6443 14.7382 13.7283 14.9521 13.7283 15.2118C13.7283 15.4716 13.6443 15.6855 13.4762 15.8535C13.3081 16.0216 13.0943 16.1056 12.8345 16.1056C12.5748 16.1056 12.3609 16.0216 12.1929 15.8535Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.da34989daa87183bab7adf079d7ab98e.svg";
export { ForwardRef as ReactComponent };